import React from 'react';
import Modal from 'react-modal';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        minWidth: '300px',
        width: '85%',
        transform: 'translate(-50%, -50%)',
        // Block flow, not flex: flex children shrink and clip instead of
        // overflowing, which stops tall dialogs from scrolling.
        display: 'block',
        maxWidth: '500px',
        maxHeight: '88vh',
        overflowY: 'auto',
        overscrollBehavior: 'contain',
        border: '1px solid #e2e8f0',
        borderRadius: '10px',
        padding: '20px',
        boxShadow: 'none'
    },
    overlay: {
        // Keep shared dialogs above fixed profile panels and nested editors.
        zIndex: 1000,
        backgroundColor: 'rgba(15, 23, 42, 0.5)',
        backdropFilter: 'blur(5px)',
        WebkitBackdropFilter: 'blur(5px)'
    }
}

const ModalComponent = ({ showModal, setShowModal, customMaxWidth, customContentStyle, customOverlayStyle, children }) => {

    Modal.setAppElement('#root')

    const mergedStyles = {
        ...customStyles,
        content: {
            ...customStyles.content,
            ...(customMaxWidth ? { maxWidth: customMaxWidth } : {}),
            ...(customContentStyle || {}),
        },
        overlay: {
            ...customStyles.overlay,
            ...(customOverlayStyle || {}),
        }
    }

    return (
        <Modal
            isOpen={showModal}
            onRequestClose={() => setShowModal(false)}
            style={mergedStyles}
            contentLabel="Example Modal">
            {children}
        </Modal>
    );
}

export default ModalComponent
